export default __webpack_public_path__ + "images/KA.efb9a19.png";